// client/src/utils/notify.js
// Tiny wrapper for window.alert() that picks Hebrew or English based on i18next state.
// Reduces the 102+ hardcoded English alert() calls across the app to a single shared
// helper. Created 2026-05-27 as part of L4 (alerts i18n) — applied to the top-3 hot
// files (Warehouse, Logistics, Supplier). Other files may still call alert() directly.
//
// Usage:
//   import { notifyError, notifyMessage } from '../../utils/notify';
//
//   try { ... } catch (err) { notifyError(err); }
//   notifyMessage('Saved successfully', 'נשמר בהצלחה');
//   notifyMessage('No data to export'); // English in both languages if no Hebrew given
//
// For per-key i18n use the standard useTranslation() pattern with t() instead.
// This helper exists for the "Failed: ${err.message}" pattern which is too repetitive
// to deserve its own key per call-site.

import i18n from 'i18next';

const isHebrew = () => (i18n?.language || '').toLowerCase().startsWith('he');

/**
 * Show an error from a thrown error / axios response.
 *  - In Hebrew: "פעולה נכשלה: <msg>"
 *  - In English: "Failed: <msg>"
 */
export function notifyError(err, customPrefix) {
  const msg = err?.response?.data?.error || err?.message || String(err);
  if (customPrefix) {
    window.alert(`${customPrefix}: ${msg}`);
    return;
  }
  if (isHebrew()) {
    window.alert(`פעולה נכשלה: ${msg}`);
  } else {
    window.alert(`Failed: ${msg}`);
  }
}

/**
 * Show a plain message. If `heMessage` is supplied, it's shown in Hebrew mode;
 * otherwise the English version is shown in both languages.
 */
export function notifyMessage(enMessage, heMessage) {
  if (heMessage && isHebrew()) {
    window.alert(heMessage);
  } else {
    window.alert(enMessage);
  }
}
